import {Box, Typography} from "@mui/material";
import sanitizeHtml from "sanitize-html";
import React from "react";
import {useIsOverflowDetected, usePrevious} from "../../common/helpers";
import Button from "@mui/material/Button";

interface DescriptionProps {
    content: string | null | undefined;
    locale: string;
}

const HTMLSanitizeOptions = {
    allowedTags: ["b", "i", "em", "strong", "a", "p"],
}

const descriptionBoxSx = {
    "collapsed": { maxHeight: "8rem", overflow: "hidden", WebkitLineClamp: "5", WebkitBoxOrient: "vertical", display: "-webkit-box" },
    "expanded": { maxHeight: "14rem", overflow: "scroll" }
}

const Description = ({content, locale}: DescriptionProps) => {
    
    const [isExpanded, setIsExpanded] = React.useState(false);
    
    const ref = React.useRef<HTMLElement>();
    
    const overflowDetected = useIsOverflowDetected(ref);
    
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    
    React.useEffect(() => {
        setIsExpanded(false);
    }, [locale]);
    
    const wasExpanded = usePrevious(isExpanded);
    
    if (content) {
        return <> 
            <Box sx={{ ...(descriptionBoxSx[isExpanded ? "expanded" : "collapsed"]), transition: "max-height 0.5s" }} ref={ref} className="customized-scrollbar">
                <Typography
                    sx={{color: 'text.secondary'}}
                    variant="body2"
                    gutterBottom
                    dangerouslySetInnerHTML={{__html: sanitizeHtml(content as string, HTMLSanitizeOptions)}} />
            </Box>
            {(overflowDetected || isExpanded || wasExpanded) && <Button
                onClick={toggleExpand}    
                variant="outlined"
                size="small"
                sx={{ fontSize: "0.6em", px: 1, py: 0, mt: 1 }}>
                { isExpanded ? "Read less" : "Read more" }
            </Button>}
        </>;
    }
    
    return null;
};

export default Description;